import { ACTION_ARGS, MODAL_ARGS, Metadata, pick, pickAll } from '../../../utils/spds/metadata';
import {
  MODAL_DOCS_CTA_BLOCKS,
  assembleModalDescription,
} from '../../../utils/spds/metadata/modal-docs';
import { ensureSafeComponent } from '@embroider/util';
import { fn, hash } from '@ember/helper';
import { tracked } from '@glimmer/tracking';
import ModalCta from './shared/footer-cta.gjs';
import StandardModal from './standard.gjs';
import Super from '../core/base.gjs';

const METADATA = Metadata.define({
  description: assembleModalDescription(
    'Used when the system requires the user to acknowledge the presented information.',
    MODAL_DOCS_CTA_BLOCKS
  ),
  extends: [
    pick(ACTION_ARGS, [{ name: 'onClose', required: true }, 'onBeforeClose', 'onOpen']),
    pickAll(MODAL_ARGS, { overrides: { title: { initialValue: 'Acknowledgement' } } }),
  ],
  name: 'Acknowledgement',
});

export default class SpdsModalAcknowledgement extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  baseClass = 'spds-modal-acknowledgement';

  @tracked footerComponent;

  get showStandardFooter() {
    let { primaryBtnAction, primaryBtnText, secondaryBtnAction, secondaryBtnText } = this.args;

    return (
      !this.footerComponent &&
      (primaryBtnAction || primaryBtnText || secondaryBtnAction || secondaryBtnText)
    );
  }

  <template>
    <StandardModal
      @closeOnClickOutside={{@closeOnClickOutside}}
      @id={{this.id}}
      @onBeforeClose={{@onBeforeClose}}
      @onClose={{@onClose}}
      @onOpen={{@onOpen}}
      @variantName={{this.componentName}}
      class={{this.classes}}
      data-test-spds-modal-acknowledgement
      {{this.validateArguments}}
      ...attributes
      as |M|
    >
      {{yield
        (hash
          Header=(ensureSafeComponent M.Header)
          Body=(ensureSafeComponent M.Body)
          Footer=(ensureSafeComponent
            M.Footer
            registerComponent=(fn this.registerComponent "footerComponent")
            unregisterComponent=(fn this.unregisterComponent "footerComponent")
          )
          beforeClose=M.beforeClose
          close=M.close
        )
      }}

      {{#if this.showStandardFooter}}
        <M.Footer>
          <ModalCta
            @beforeClose={{M.beforeClose}}
            @close={{M.close}}
            @primaryBtnAction={{@primaryBtnAction}}
            @primaryBtnText={{@primaryBtnText}}
            @primaryBtnDisabled={{@primaryBtnDisabled}}
            @secondaryBtnAction={{@secondaryBtnAction}}
            @secondaryBtnText={{@secondaryBtnText}}
            @secondaryBtnDisabled={{@secondaryBtnDisabled}}
          />
        </M.Footer>
      {{/if}}
    </StandardModal>
  </template>
}

export const MODAL_ACKNOWLEDGEMENT_METADATA = SpdsModalAcknowledgement.metadata;
